export type Company = {
    id: string;
    name: string;
    isEnergyHarbourCustomer: boolean;
};

export function Company_normalize(company: Company): Company {
    return {
        id: company.id ?? "",
        name: company.name ?? "",
        isEnergyHarbourCustomer: company.isEnergyHarbourCustomer ?? false
    };
}